import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Repositories from './repositories/repositories';
import Home from './Home/Home'

export default function AllRoutes () {
    return(
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path='/' element={<Home/>} />
                <Route path='/repositories' element={<Repositories/>} />
            </Routes>
        </BrowserRouter>
    )
}